const isFiniteNumber = (val: unknown): val is number => {
    if (typeof val === 'number') { return Number.isFinite(val); }

    return false;
};

export default isFiniteNumber;
